import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import parse from "html-react-parser";
export const invoiceInsideColumns ={ 
  creditCardSubColumns:[
  {
    Header: 'Invoice No.',
    accessor: 'invoiceNo',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='invoiceNo text-secondary-blue'>
          {row.original.invoiceID}
        </span>
      );
    },
  },
  {
    Header: 'Order No.',
    accessor: 'fileNumber',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='fileNumber text-secondary-blue'>
          {row.original.fileNumber}
        </span>
      );
    },
  },
  {
    Header: 'Your File/Reference No.',
    accessor: 'internalRefernece',
  },
  {
    Header: 'Deal Type',
    accessor: 'dealType',
  },
  {
    Header: 'Lawyer/Notary',
    accessor: 'lawyerName',
  },
  {
    Header: 'Client Name',
    accessor: 'clients',
  },
  {
    Header: 'Property Address',
    accessor: 'propertyAddress',
    Cell: ({ row }) => {
      return (
        <span>
          {parse(row.original.propertyAddress?.replaceAll('<br>','</br>'))}
        </span>
      );
    },
  },
  {
    Header: 'Closing Date',
    accessor: 'closingDate',
  },
  {
    Header: 'Payment Total',
    accessor: 'invoiceTotal',
  },
  {
    Header: 'Paid By',
    accessor: 'paidBy',
  },
  
],
EFTSubColumns:[

  {
    Header: 'Batch No.',
    accessor: 'eftBatchID',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='invoiceNo text-secondary-blue'>
          {row.original.invoiceID}
        </span>
      );
    },
  },
  {
    Header: 'Invoice No.',
    accessor: 'invoiceID',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='invoiceNo text-secondary-blue'>
          {row.original.invoiceID}
        </span>
      );
    },
  },
  {
    Header: 'Order No.',
    accessor: 'fileNumber',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='fileNumber text-secondary-blue'>
          {row.original.fileNumber}
        </span>
      );
    },
  },
  {
    Header: 'Your File/Reference No.',
    accessor: 'internalRefernece',
  },
  {
    Header: 'Deal Type',
    accessor: 'dealType',
  },
  {
    Header: 'Lawyer/Notary',
    accessor: 'lawyerName',
  },
  {
    Header: 'Client Name',
    accessor: 'clients',
  },
  {
    Header: 'Property Address',
    accessor: 'propertyAddress',
    Cell: ({ row }) => {
      return (
        <span>
          {parse(row.original.propertyAddress?.replaceAll('<br>','</br>'))}
        </span>
      );
    },
  },
  {
    Header: 'Closing Date',
    accessor: 'closingDate',
  },
  {
    Header: 'Payment Total',
    accessor: 'invoiceTotal',
  },
 
]
,
CheuqueSubColumns:[

  {
    Header: 'Cheque No.',
    accessor: 'chequeNumber',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='invoiceNo text-secondary-blue'>
          {row.original.invoiceID}
        </span>
      );
    },
  },
  {
    Header: 'Invoice No.',
    accessor: 'invoiceID',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='invoiceNo text-secondary-blue'>
          {row.original.invoiceID}
        </span>
      );
    },
  },
  {
    Header: 'Order No.',
    accessor: 'fileNumber',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='fileNumber text-secondary-blue'>
          {row.original.fileNumber}
        </span>
      );
    },
  },
  {
    Header: 'Your File/Reference No.',
    accessor: 'internalRefernece',
  },
  {
    Header: 'Deal Type',
    accessor: 'dealType',
  },
  {
    Header: 'Lawyer/Notary',
    accessor: 'lawyerName',
  },
  {
    Header: 'Client Name',
    accessor: 'clients',
  },
  {
    Header: 'Property Address',
    accessor: 'propertyAddress',
    Cell: ({ row }) => {
      return (
        <span>
          {parse(row.original.propertyAddress?.replaceAll('<br>','</br>'))}
        </span>
      );
    },
  },
  {
    Header: 'Closing Date',
    accessor: 'closingDate',
  },
  {
    Header: 'Payment Total',
    accessor: 'invoiceTotal',
  },
 
],
PreAuthSubColumns:[
  {
    Header: 'Invoice No.',
    accessor: 'invoiceNo',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='invoiceNo text-secondary-blue'>
          {row.original.invoiceID}
        </span>
      );
    },
  },
  {
    Header: 'Order No.',
    accessor: 'fileNumber',
    Cell: ({ row }) => {
      //spread the props

      return (
        <span className='fileNumber text-secondary-blue'>
          {row.original.fileNumber}
        </span>
      );
    },
  },
  {
    Header: 'Your File/Reference No.',
    accessor: 'internalRefernece',
  },
  {
    Header: 'Deal Type',
    accessor: 'dealType',
  },
  {
    Header: 'Lawyer/Notary',
    accessor: 'lawyerName',
  },
  {
    Header: 'Client Name',
    accessor: 'clients',
  },
  {
    Header: 'Property Address',
    accessor: 'propertyAddress',
    Cell: ({ row }) => {
      return (
        <span>
          {parse(row.original.propertyAddress?.replaceAll('<br>','</br>'))}
        </span>
      );
    },
  },
  {
    Header: 'Closing Date',
    accessor: 'closingDate',
  },
  {
    Header: 'Payment Total',
    accessor: 'invoiceTotal',
  },
  {
    Header: 'Paid By',
    accessor: 'paidBy',
  },
  
 
]
};

export const formatRowData = (rawData) => {
  return rawData?.map((info) => ({
    paymentNo: info.paymentNo,
    paymentDate: info.paymentDate,
    PaymentMethod: info.PaymentMethod,
    ccCardType: info.ccCardType,
    ccMaskNumber: info.ccMaskNumber,
    paymentTotal: info.paymentTotal,
    paidBy: info.paidBy,
    invoiceDetails: info.invoiceDetails,
    // invoiceLineItems: info.invoiceDetails[0].invoiceLineItems,
  }));
};

export const getData = async (pageNo = 1) => {
  const response = await fetch(
    `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=15`
  );
  const data = await response.json();
  return data;
  //   fetch(
  //     `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=10`
  //   ).then((res) => res.json().then((data) => console.log(data)));
};
